import React, { useEffect, useRef, useState } from 'react';
import Layout from './Layout/Layouts';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import AppRoutes from './Router/Index';
import { SnackbarProvider } from 'notistack';
import { useUserStore } from './store/user';
import { Button } from '@mui/material';
import http from './api/axiosInstance';
import { useSnackbar } from 'notistack';
import { useSearchPropStore } from './store/searchProperty';
import { GetAgency } from './Components/PublicFunctions';
import Cookies from 'js-cookie'
import {MarketProvider} from "./context/MarketContext";
 




function App() {




  const accessToken = useUserStore((state) => state.accessToken)
  // const appVersion = useUserStore((state) => state.appVersion)
  const setToken = useUserStore((state) => state.setToken)
  const setUserInfo = useUserStore((state) => state.setUserInfo)

  const locationId = useUserStore((state) => state.locationId)
  const setLocationId = useUserStore((state) => state.setLocationId)
  // const locationName = useUserStore((state) => state.locationName)
  const setLocationName = useUserStore((state) => state.setLocationName)

  const setSearchData = useSearchPropStore((state) => state.setSearchData)
  const notistackRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {

    
    

    if (accessToken == "")
      if (Cookies.get('token'))
        setToken(Cookies.get('token'))

    if (Cookies.get('agency'))
      setUserInfo(JSON.parse(Cookies.get('agency')))

    if (Cookies.get('locationId'))
      setLocationId(Cookies.get('locationId'))
    // else
    //   if (Cookies.get('agency')) {
    //     setLocationId(JSON.parse(Cookies.get('agency')).LocationId)
    //     console.log("LocationId", JSON.parse(Cookies.get('agency')).LocationId)
    //   }

    if (Cookies.get('locationName'))
      setLocationName(Cookies.get('locationName'))
    else
      if (Cookies.get('agency'))
        setLocationName(JSON.parse(Cookies.get('agency')).LocationName)

    GetAgency(setUserInfo, setSearchData, () => { }, http,true)
    // try {
    //   http({
    //     // url of the api endpoint (can be changed)
    //     url: "/authenticate/get/agency",
    //     method: "GET",
    //     headers: {
    //       "Authorization": `Bearer ${Cookies.get('token')}`
    //     }
    //   }).then((res) => {
    //     console.log("get/agency",res)
    //     localStorage.setItem('agency', JSON.stringify(res.data.result))
    //     // localStorage.setItem('locationId', res.data.result.LocationId)
    //     setUserInfo(res.data.result)

    //     setSearchData({ name: 'AgencyId', value: res.data.result.Id })
    //     // setSearchData({ name: 'LocationId', value: res.data.result.LocationId })
    //   });
    // } catch (e) {
    //   console.error(e);

    //   if (e.response.data.result == false) {
    //     const variant = 'error'
    //     enqueueSnackbar(e.response.data.message, { variant });
    //   }

    // }

  }, [])
  console.log("locationId : ", locationId)
  return (
    <Router>
      <Layout>

        <SnackbarProvider action={(key) => (
          <Button
            onClick={() => notistackRef.current.closeSnackbar(key)}
            style={{
              height: '100%',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%'
            }}
          >

          </Button>
        )} autoHideDuration={2000} maxSnack={3} ref={notistackRef}
        >
          <MarketProvider>
            <AppRoutes />
          </MarketProvider>

        </SnackbarProvider>

      </Layout>
    </Router>
  )
}

export default App;
